<template>
  <vx-card no-shadow >
    <a-form :form="form" @submit.prevent="handleSubmitAccount">
      <div class="flex justify-between">
        <div class="text-2xl font-semibold self-end">
          Account
        </div>
        <div class="flex space-x-2 mt-5">
          <a-button type="primary" ghost @click="$emit('changeTab','UserSettingsGeneral')" style="border-radius: 3px !important;">Cancel</a-button>
          <a-button type="primary" html-type="submit" style="border-radius: 3px !important;">Save</a-button>
        </div>
      </div>
      <a-divider/>
      <div>
        <h4 class="title-account">Firm</h4>
        <div class="pl-5">
          <a-form-item label="Firm name">
            <a-input v-decorator="['firm_name',{ initialValue: null,rules: [{ required: true,message:'This field is required.' }] }]" />
          </a-form-item>
        </div>
      </div>
      <div>
        <h4 class="title-account pt-5">Mailing Address</h4>
        <div class="pl-5">
          <a-form-item label="Street">
            <a-input v-decorator="['street',{ initialValue: null,rules: [{ required: false,message:'This field is required.' }] }]" />
          </a-form-item>
          <div class="flex space-x-4">
            <a-form-item label="City" class="w-1/2">
              <a-input v-decorator="['city',{ initialValue: null,rules: [{ required: false,message:'This field is required.' }] }]"/>
            </a-form-item>
            <a-form-item label="State/Province" class="w-1/2">
              <a-input v-decorator="['state',{ initialValue: null,rules: [{ required: false,message:'This field is required.' }] }]"/>
            </a-form-item>
          </div>
          <div class="flex space-x-4 w-full">
            <a-form-item label="Country" class="w-1/2">
              <a-select
                v-decorator="[`country`,{ initialValue:null,rules: [{ required: true,message:'This field is required.' }] }]"
                placeholder="Country"
                class="country"
                allowClear
                show-search
                autocomplete="none"
                :filter-option="filterOption"
              >
                <a-icon slot="suffixIcon" type="search" />
                <a-select-option v-for="city in cities" :value="city.name">
                  {{ city.name }} ({{ city.code }})
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Post Code" class="w-1/2">
              <a-input v-decorator="[`post_code`,{ initialValue:null,rules: [{ required: false,message:'This field is required.' }] }]"/>
            </a-form-item>
          </div>
        </div>
      </div>
      <a-divider/>
      <div>
        <h4 class="title-account">Contact information</h4>
        <div class="pl-5">
          <div class="flex space-x-4">
            <a-form-item label="Phone number" class="w-1/3">
              <a-input
                :max-length="13"
                v-decorator="[
                  'phone',
                  {
                    initialValue: null,
                    rules: [
                      { pattern: /^\+?\d*$/, type: 'string', required: false,  message: 'Invalid phone number.' },
                      { required: false, message:'This field is required.' }
                    ]
                  }
                ]"
              />
            </a-form-item>
            <a-form-item label="Fax" class="w-2/3">
              <a-input v-decorator="['fax',{ initialValue: null,rules: [{ required: false,message:'This field is required.' }] }]"/>
            </a-form-item>
          </div>
          <div class="flex space-x-4">
            <a-form-item label="Email" class="w-1/2">
              <a-input v-decorator="['contact_email',{ initialValue: null,rules: [{ required: false,message:'This field is required.' },{ pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, required: false,message: 'format email is invalid.' }] }]"/>
            </a-form-item>
            <a-form-item label="Website" class="w-1/2">
              <a-input v-decorator="['contact_website',{ initialValue: null,rules: [{ required: false,message:'This field is required.' }] }]"/>
            </a-form-item>
          </div>
        </div>
      </div>
<!--      <a-divider/>-->
<!--      <div>-->
<!--        <h4 class="title-account">Date and Time Format</h4>-->
<!--        <div class="pl-5">-->
<!--          <div class="flex space-x-4">-->
<!--            <a-form-item label="Date format" class="w-1/2">-->
<!--              <a-select-->
<!--                v-decorator="[`date_format`,{ initialValue:1,rules: [{ required: false,message:'This field is required.' }] }]"-->
<!--                allowClear-->
<!--                show-search-->
<!--                autocomplete="none"-->
<!--                :filter-option="filterOption"-->
<!--              >-->
<!--                <a-select-option :value="1">-->
<!--                  {{moment('MM-DD-YYYY')}}-->
<!--                </a-select-option>-->
<!--                <a-select-option :value="2">-->
<!--                  {{moment('DD-MM-YYYY')}}-->
<!--                </a-select-option>-->
<!--                <a-select-option :value="3">-->
<!--                  {{moment('YYYY-DD-MM')}}-->
<!--                </a-select-option>-->
<!--                <a-select-option :value="4">-->
<!--                  {{moment('MM.DD.YYYY')}}-->
<!--                </a-select-option>-->
<!--              </a-select>-->
<!--            </a-form-item>-->
<!--            <a-form-item label="Time format" class="w-1/2">-->
<!--              <a-select-->
<!--                v-decorator="[`time_format`,{ initialValue:1,rules: [{ required: false,message:'This field is required.' }] }]"-->
<!--                allowClear-->
<!--                show-search-->
<!--                autocomplete="none"-->
<!--              >-->
<!--                <a-select-option :value="1">-->
<!--                  {{moment('hh:mm A')}}-->
<!--                </a-select-option>-->
<!--                <a-select-option :value="2">-->
<!--                  {{moment('HH:mm a')}}-->
<!--                </a-select-option>-->
<!--                <a-select-option :value="3">-->
<!--                  {{moment('HH:mm')}}-->
<!--                </a-select-option>-->
<!--              </a-select>-->
<!--            </a-form-item>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </a-form>
<!--    <a-tabs default-active-key="1">-->
<!--      <a-tab-pane key="1" tab="Account info">-->
<!--  -->
<!--      </a-tab-pane>-->
<!--      <a-tab-pane key="2" tab="Payment info" force-render>-->
<!--        Content of Tab Pane 2-->
<!--      </a-tab-pane>-->
<!--    </a-tabs>-->
  </vx-card>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import axios from '@/axios'
import mixin from '../../../mixin/mixin'
import moment from 'moment'
import XUpload from "@/components/x-upload/XUpload";

export default {
  components: {
    flatPickr,
    vSelect,
    moment,
    XUpload
  },
  mixins:[mixin],
  data () {
    return {
      cities: [],
    }
  },
  methods:{
    handleSubmitAccount(){
      this.form.validateFields(async (err,values)=>{
        if(!err){
          try{
            this.$vs.loading()
            await axios.put('/setting/firm/',{accounts:values})
            this.$notification['success']({
              message: 'Success',
              description: `Account success.`,
            });
            const userConfig = await axios.get('/setting/firm/currency')
            localStorage.setItem('currency_symbol', userConfig.data.setting.accounts.currency)
            this.$emit('changeTab','UserSettingsGeneral')
          }catch (e) {
            this.$notification['error']({
              message: 'Failed',
              description: `Account failed.`,
            });
          }finally {
            this.$vs.loading.close()
          }
        }
      })
    },
    async getOneAccount(){
      try{
        this.$vs.loading()
        const { data } = await axios.get('/setting/firm/accounts/')
        this.form.setFieldsValue(data)
      }catch (e) {
        this.$message.error('Error receiving data.')
      }finally {
        this.$vs.loading.close()
      }
    },
    async getCity(){
      const { data } = await axios.post('/dictionary/country/')
      this.cities = data
    },
    moment (format) {
      return moment(new Date()).format(format)
    }
  },
  mounted() {
    this.getOneAccount()
    this.getCity()
  }
}
</script>


<style>
    .input-file .ant-input{
        border-top-left-radius: 3px !important;
        border-bottom-left-radius: 3px !important;
        border-top-right-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
    }
    .input-file .ant-input-group-addon{
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-top-right-radius: 3px !important;
        border-bottom-right-radius: 3px !important;
    }
    .ant-input{
        border-radius: 3px;
    }
    .upload-photo,.time-picker .ant-time-picker-input{
        border-radius: 3px !important;
    }
    .title-account{
        color: darkgray !important;
    }
    .ant-time-picker,.ant-calendar-picker{
        width: 100%;
    }

</style>
